'use client';

import { dailyBonusStateService } from '../dailyBonus.state.service';
import { useObservable } from '../observable';

export const useDailyBonusState = () => {
  return {
    dailyBonusBlocks: useObservable(dailyBonusStateService.dailyBonusBlocks),
    dailyBonusBlocksNextDate: useObservable(dailyBonusStateService.dailyBonusBlocksNextDate),
    dailyBonusIndexToCollect: useObservable(dailyBonusStateService.dailyBonusIndexToCollect),
    setDailyBonusBlocks: dailyBonusStateService.setDailyBonusBlocks,
    setDailyBonusBlocksNextDate: dailyBonusStateService.setDailyBonusBlocksNextDate,
    setDailyBonusIndexToCollect: dailyBonusStateService.setDailyBonusIndexToCollect,
    clear: dailyBonusStateService.clear,
  };
};
